/* eslint-disable */
import {
  lista,
  processar,
  pegaLista,
  pegaDados,
  nao_autorizado,
  processaArquivo,
  processaMultiFiles
} from '../../services/GenericAPI'
import {SoftwareUpdateSCH, getSoftwareUpdateSCH} from "../../search/SoftwareUpdateSCH"
import {Filtro, Join, Left, Where} from "../../models/filtro/filtro";
import {SoftwareUpdate} from '../../models/software_update'
import {EventBus} from '../../helpers/event-bus'
import {getBaseSCH} from '../../search/BaseSCH'

const url = '/software_update'

const state = {
  all: [],
  allList: [],
  software_update: new SoftwareUpdate(),
  filtro: new Filtro(),
  is_cancelado: false,
  editando: false,
}

const getters = {
  listaAllSoftwareUpdates: (state) => {
    return state.allList !== null && state.allList !== undefined ? state.allList : []
  },
  listaSoftwareUpdates: (state) => {
    return state.all
  },
  pegaSoftwareUpdate: (state) => {
    return state.software_update
  },
  pegaFiltro: (state) => {
    return state.filtro
  },
  pegarIsCancelado: (state) => {
    return state.is_cancelado
  },
}

const actions = {
  async uploadArquivoInChunks({commit},{software_update, software_update_arquivo, onSucesso,onErro,onProgresso}) {
    try {

      const chunkSize = 1024 * 1024; // 1MB
      const file = software_update_arquivo.arquivo;
      const size = file.size
      let totalChunks = Math.ceil(size / chunkSize);

      //  Inicia o upload resumável
      var item = {
        software_update: JSON.stringify(software_update),
        software_update_arquivo: JSON.stringify(software_update_arquivo),
        originalName: file.name
      }

      let startResponse = await processar(url+'/start-resumable-upload', item)

      const { upload_id } = await startResponse.data;

      var arquivo = software_update_arquivo.arquivo

      // console.log('Envia os chunks: ', arquivo)

      // console.log('totalChunks: ', totalChunks)
      if(software_update_arquivo['status'] === 'E'){
        totalChunks = 1
      }

      // 2️⃣ Envia os chunks
      for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
        // console.log('software_update_arquivo: ', software_update_arquivo)

        const start = chunkIndex * chunkSize;
        const end = Math.min(start + chunkSize, file.size);
        const chunk = file.slice(start, end);

        const formData = new FormData();
        formData.append('file', chunk);
        formData.append('upload_id', upload_id);
        formData.append('chunkIndex', chunkIndex);
        formData.append('totalChunks', totalChunks);
        formData.append('chunkSize', chunkSize);
        formData.append('is_cancelado', state.is_cancelado);
        formData.append('originalName', arquivo.name);
        formData.append('software_update', JSON.stringify(software_update));
        formData.append('software_update_arquivo', JSON.stringify(software_update_arquivo));

        let response = await processar(url+'/upload-chunk', formData)

        if (response.data.status==='cancelado') {
          console.log('CANCELANDO')
          break
        }

        // console.log(`Enviado chunk ${chunkIndex + 1}/${totalChunks}`);

        const percentual = Math.round(((chunkIndex + 1) / totalChunks) * 100);

        onProgresso(percentual, chunkIndex+1 === totalChunks-1);
        // onProgresso(percentual, tempoDecorridoSeg, tempoRestanteSeg);
      }

      // console.log("Upload concluído com sucesso!");
      onSucesso()
    } catch (error) {
      console.log(error)
      onErro(error)
    }


  },




  searchItem({commit}, search) {
    state.filtro.filters.search = [];
    state.filtro.filters.addSearch(['software_update_key','descricao'],
      '%'+search+'%',
      'ilike'
    )
  },
  async getItem({commit}, {id,onSucesso,onErro}) {
    try {
      let filtro = getBaseSCH('software_update_id', id, '=');

      const list = (await pegaDados(url+'/get_software_update', filtro)).data;
      onSucesso( list.data[0])
      // commit('SET_SOFTWARE_UPDATE', list.data[0])
    } catch (error) {
      console.log(error)
      onErro()
    }

  },

  setFiltro({commit}, perPage) {
    commit('SET_FILTRO', SoftwareUpdateSCH(perPage))
  },
  async setAllListSoftwareUpdates({commit},{onSucesso}) {
    const list = (await lista(url + '/all')).data
    commit('SET_ALL_LIST', list)
    onSucesso()
  },

  async setAllSoftwareUpdates({commit},{onSucesso,onErro}) {
    try {
      const list = (await pegaDados(url + '/get_software_update', state.filtro)).data
      commit('SET_SOFTWARE_UPDATES', list)
      onSucesso()
    } catch (error) {
      console.log(error)
      nao_autorizado(error)
      onErro()
    }
  },

  async getHashSoftwareUpdate({commit},{filtro,onSucesso,onErro}) {
    try {
      const list = (await pegaDados(url + '/get_hash_software', filtro)).data
      onSucesso(list)
    } catch (error) {
      console.log(error)
      nao_autorizado(error)
      onErro()
    }
  },
  async getVersaoSoftwareUpdate({commit},{filtro,onSucesso,onErro}) {
    try {
      const list = (await pegaDados(url + '/get_versao_software', filtro)).data
      onSucesso(list)
    } catch (error) {
      console.log(error)
      nao_autorizado(error)
      onErro()
    }
  },
  async getTotalCliente({commit},{filtro,onSucesso,onErro}) {
    try {
      const list = (await pegaDados(url + '/get-total-cliente', filtro)).data
      onSucesso(list)
    } catch (error) {
      console.log(error)
      onErro()
    }
  },


  async processarSoftwareUpdate({commit}, {path,acao, onSucesso, onErro}) {
    try {

      let res = await processar(url+'/'+path, state.software_update, acao)
      onSucesso(res)
    } catch (error) {
      this.dispatch('geral/setObjMsgError', error.response.data)
      onErro()
    }
  },
  setSoftwareUpdate({commit}, software_update) {
    commit('SET_SOFTWARE_UPDATE', software_update)
  },
  setEditando({commit}, edit) {
    commit('SET_EDITANDO', edit)
  },
  setIsCancelado({commit}, edit) {
    commit('SET_ISCANCELADO', edit)
  },
}

const mutations = {
  SET_ISCANCELADO(state, edit) {
    state.is_cancelado = edit
  },
  SET_EDITANDO(state, edit) {
    state.editando = edit
  },
  SET_ALL_LIST(state, filtro) {
    state.allList = filtro
  },
  SET_FILTRO(state, filtro) {
    state.filtro = filtro
  },
  SET_SOFTWARE_UPDATES(state, software_updates) {
    state.all = software_updates
  },
  SET_SOFTWARE_UPDATE(state, software_update) {
    state.software_update = software_update
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
